import { AddDraftLog } from "components/timesheet/add-draft-log";
import { HeaderDescription, HeaderTitle } from "components/timesheet/header";
import {
  DraftTimesheetEntries,
  TimesheetLoading,
  TimesheetRoot,
} from "components/timesheet/timesheet";
// import AddLogCard from "components/timesheet/card/add-log";
import DraftEntryCard from "components/timesheet/card/draft-entry";
import { LogByDayLoader } from "@/modules/timesheet/logs/views/week/loader";
import { TIMESHEET_DRAFT_DAY_VIEW } from "@/lib/utils";
import { DraftTimesheetLogProvider } from "components/timesheet/context/draft-log";
import Lock from "components/timesheet/lock";

export default function TimesheetDraftByDay({ date }) {
  return (
    <>
      <DraftTimesheetLogProvider date={date}>
        <TimesheetLoading>
          <LogByDayLoader />
        </TimesheetLoading>
        <TimesheetRoot>
          <div className="lg:pt-6 pt-4">
            <div className="flex flex-col gap-6 lg:px-6 px-4">
              <div className="flex justify-between md:items-center md:gap-6 gap-4 md:flex-row flex-col">
                <div>
                  <div className="flex items-center">
                    <HeaderTitle className="text-xl font-semibold " />
                  </div>
                  <HeaderDescription className="text-sm text-muted-foreground mt-1" />
                </div>
              </div>
            </div>
            <div className="mt-4 pl-4 lg:pl-6 flex gap-4.5 overflow-x-auto no-scrollbar py-1">
              <DraftTimesheetEntries>
                {({ entry }) => (
                  <DraftEntryCard
                    key={entry.id}
                    entry={entry}
                    href={`/${TIMESHEET_DRAFT_DAY_VIEW}/${entry.id}`}
                  />
                )}
              </DraftTimesheetEntries>
              <Lock>
                <AddDraftLog />
              </Lock>
            </div>
          </div>
        </TimesheetRoot>
      </DraftTimesheetLogProvider>
    </>
  );
}
